import BasicGame from './basicGame';
import GameState from './types/GameState';

// TODO
// undo
// offer draw
// resign
// board history
// actions

class Game extends BasicGame {
  ['constructor']!: typeof Game

  constructor(obj: GameState) {
    super(obj);
    console.log('Game created');
  }
}

export default Game;
